export var CustomerStatuses;
(function (CustomerStatuses) {
    CustomerStatuses["active"] = "active";
    CustomerStatuses["disabled"] = "disabled";
    CustomerStatuses["suspended"] = "suspended";
    CustomerStatuses["blocked"] = "blocked";
    CustomerStatuses["inactive"] = "inactive";
})(CustomerStatuses || (CustomerStatuses = {}));
export var AccountStatuses;
(function (AccountStatuses) {
    AccountStatuses["active"] = "active";
    AccountStatuses["disabled"] = "disabled";
    AccountStatuses["inactive"] = "inactive";
})(AccountStatuses || (AccountStatuses = {}));
export var PaymentIntentStatus;
(function (PaymentIntentStatus) {
    PaymentIntentStatus["Canceled"] = "canceled";
    PaymentIntentStatus["Processing"] = "processing";
    PaymentIntentStatus["RequiresAction"] = "requires_action";
    PaymentIntentStatus["RequiresCapture"] = "requires_capture";
    PaymentIntentStatus["RequiresConfirmation"] = "requires_confirmation";
    PaymentIntentStatus["RequiresPaymentMethod"] = "requires_payment_method";
    PaymentIntentStatus["Succeeded"] = "succeeded";
})(PaymentIntentStatus || (PaymentIntentStatus = {}));
export var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["active"] = "active";
    SubscriptionStatus["canceled"] = "canceled";
    SubscriptionStatus["incomplete"] = "incomplete";
    SubscriptionStatus["incomplete_expired"] = "incomplete_expired";
    SubscriptionStatus["past_due"] = "past_due";
    SubscriptionStatus["paused"] = "paused";
    SubscriptionStatus["trialing"] = "trialing";
    SubscriptionStatus["unpaid"] = "unpaid";
})(SubscriptionStatus || (SubscriptionStatus = {}));
export var TransactionTypes;
(function (TransactionTypes) {
    TransactionTypes["usage"] = "usage";
    TransactionTypes["usage_correction"] = "usage_correction";
    TransactionTypes["subscription"] = "subscription";
    TransactionTypes["refill"] = "refill";
    TransactionTypes["bonus"] = "bonus";
})(TransactionTypes || (TransactionTypes = {}));
export var BonusSource;
(function (BonusSource) {
    BonusSource["manual"] = "MANUAL";
    BonusSource["registration"] = "REGISTRATION";
    BonusSource["subscription"] = "SUBSCRIPTION";
})(BonusSource || (BonusSource = {}));
export var TransactionStatuses;
(function (TransactionStatuses) {
    TransactionStatuses["success"] = "success";
    TransactionStatuses["failed"] = "failed";
    TransactionStatuses["pending"] = "pending";
})(TransactionStatuses || (TransactionStatuses = {}));
export var SubscriptionStatuses;
(function (SubscriptionStatuses) {
    SubscriptionStatuses["active"] = "active";
    SubscriptionStatuses["disabled"] = "disabled";
    SubscriptionStatuses["blocked"] = "blocked";
})(SubscriptionStatuses || (SubscriptionStatuses = {}));
//# sourceMappingURL=types.js.map